<template>
  <div class="ab_grouped_folds">
    <HaPosition v-if="sizeMode !== 'C'" />
    <HaAction
      :showBetsIn="showBetsIn"
      :spot="spot"
    >
      {{
        $t('analyze.hand.action.folds', {
          numOfFolds: spot.folds_length,
        })
      }}
    </HaAction>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import HaAction from '@/components/AnalyzeStreetBlocks/HaAction'
import HaPosition from '@/components/AnalyzeStreetBlocks/HaPosition'

export default {
  name: 'HaGroupedFolds',

  components: {
    HaAction,
    HaPosition,
  },
  mixins: [format_mix],
  props: {
    spot: Object,
    folds: [Number, String],
    sizeMode: { default: () => 'L' },
    showBetsIn: String,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_grouped_folds {
    display: flex;
  }
}
</style>
